import React from "react";
import { Funnel } from "lucide-react";

const EmployeeReport = ({
  absentTop10 = [],
  lateTop10 = [],
  loading = false,
}) => {
  const renderTable = (title, data) => (
    <div className="dashcard5-container p-3 shadow-sm rounded bg-white h-100">
      <h6 className="m-0 fw-semibold">{title}</h6>

      {loading ? (
        <div className="d-flex justify-content-center align-items-center py-5">
          <div
            className="spinner-border text-primary"
            style={{ width: "2.5rem", height: "2.5rem" }}
          />
        </div>
      ) : (
        <div className="table-responsive">
          <table className="table table-hover table-sm mt-3 mb-0">
            <thead>
              <tr
                className="small text-muted"
                style={{ borderBottom: "1px solid #e4e4e7" }}
              >
                <th>Code</th>
                <th>Name</th>
                <th>Count</th>
              </tr>
            </thead>

            <tbody>
              {data.length > 0 ? (
                data.map((emp) => (
                  <tr key={emp.id || emp.code}>
                    <td>{emp.code}</td>
                    <td>{emp.name}</td>
                    <td>{emp.count}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={5} className="text-center text-muted py-5">
                    No data available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center gap-2 mb-3">
        <h6 className="m-0 fw-semibold text-nowrap d-flex align-items-center gap-2">
          <Funnel size={16} /> Employee Report
        </h6>
      </div>

      <div className="row g-3">
        <div className="col-lg-6 col-sm-12">
          {renderTable("Top 10 Absent (Current Month)", absentTop10)}
        </div>
        <div className="col-lg-6 col-sm-12">
          {renderTable("Top 10 Late (Current Month)", lateTop10)}
        </div>
      </div>
    </div>
  );
};

export default EmployeeReport;
